import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useField } from 'formik'

import { Box, CircularProgress, FormControl } from '@mui/material'
import AutocompleteCustom from '@/views/components/autocomplete-custom/index.component'
import { ApplicationState } from '@/state/root.models'

import useReportsActions from '@/views/reports/hooks/use-reports-actions.hooks'

type Props = {
  handleChangeSearch: (field: string, value: any) => void
}

const GamesProviderFilterType = ({ handleChangeSearch }: Props) => {
  const { t } = useTranslation()

  const { getAllProviders } = useReportsActions()

  const [fieldGameProvider] = useField('gameProvider')

  const { providers, isLoadingProviders } = useSelector(
    ({ bonusEngine }: ApplicationState) => bonusEngine,
  )

  return (
    <FormControl fullWidth margin="none">
      <AutocompleteCustom
        id="gameProvider"
        name="gameProvider"
        placeholder={
          fieldGameProvider.value === '' || fieldGameProvider.value.length === 0
            ? t('labels.selectProviders')
            : ''
        }
        value={
          Array.isArray(fieldGameProvider.value) ? fieldGameProvider.value : []
        }
        options={providers}
        getOptionLabel={(option: any) => `${option.name} (ID: ${option.id})`}
        isOptionEqualToValue={(option: any, value: any) =>
          option.id === value.id
        }
        limitTags={1}
        // chipTags
        multiple
        onChange={(_, newValue: any[]) => {
          const selectedValue =
            newValue.length > 0 ? [newValue[newValue.length - 1]] : []
          handleChangeSearch('gameProvider', selectedValue)
        }}
        onOpen={() => {
          if (providers.length === 0) {
            getAllProviders(true)
          }
        }}
        label={t('labels.gameProvider')}
        sx={{ '& .MuiFormControl-root': { marginTop: '8px' } }}
      />
      {isLoadingProviders && (
        <Box position="absolute" right={41} top={17}>
          <CircularProgress variant="indeterminate" size={30} />
        </Box>
      )}
    </FormControl>
  )
}
export default GamesProviderFilterType
